<!-- If not Insights Data point Column -->
<span *ngIf = " !isDataPointClick && !showSimpleColumn " >
    <span class="FunnelCols" id ="FunnelCount" >{{eventNumber}} % </span> 
    <span *ngIf ="+percentCompareValue!=0" class="{{percentCompareClass}}"> {{percentCompareValue}}% </span>  
</span>
<span *ngIf = " !isDataPointClick && showSimpleColumn " >
    <span class="FunnelCols" id ="FunnelCount" > {{showSimpleColumnVal}} </span> 
</span>    

<!-- If Insights Data point Column  -->
<span *ngIf = " isDataPointClick && !showSimpleColumn "  (click) = "onClick( )" >
    <span class="FunnelCols insight-data-point" style="color: #143F93 !important;" id ="FunnelCount" >{{eventNumber}} % </span> 
    <span *ngIf ="+percentCompareValue!=0" style="color: #143F93 !important;" class="{{percentCompareClass}}"> {{percentCompareValue}}% </span>  
</span>
<span *ngIf = " isDataPointClick && showSimpleColumn "  class="insight-data-point" (click) = "onClick( )" >
    <span class="FunnelCols" id ="FunnelCount" style="color: #143F93 !important;"> {{showSimpleColumnVal}} </span> 
</span>    

